import src from "IMAGE";
export default { src, width: 1056, height: 308, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAKElEQVR42l3IoREAMAgEQfrvNbFEHHwGB4g1a+5PBVBEDpCynd256AMjoT8moGqSmwAAAABJRU5ErkJggg=="};
